export const dynamicStatus = (value) => {
    switch (value) {
      case "Approved":
        return "success";
      case "Pending":
        return "warning";
      default:
        return "error"; 
    }
  };